// src/pages/creator-panel/CallLogs/tabs/TranscriptsTab.js
// Chat-style transcript bubbles. The Recording / WaveformPlayer is rendered
// one level up in CallDetailDialog so it stays visible across tab switches.
import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { ThumbDownAltOutlined as ThumbDownIcon } from '@mui/icons-material';

const TranscriptsTab = ({ session }) => {
    const turns = session?.transcript_turns || [];

    if (turns.length === 0) {
        return (
            <Typography color="text.disabled" sx={{ textAlign: 'center', py: 4, fontStyle: 'italic' }}>
                No transcript captured for this call.
            </Typography>
        );
    }

    return (
        <Box>
            {turns.map((turn) => {
                const isAssistant = turn.role === 'assistant';
                return (
                    <Box
                        key={turn.id || turn.sequence}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: isAssistant ? 'flex-start' : 'flex-end',
                            mb: 2,
                        }}
                    >
                        <Box
                            sx={{
                                maxWidth: '70%',
                                bgcolor: isAssistant ? 'action.hover' : 'action.selected',
                                border: '1px solid', borderColor: 'divider',
                                borderRadius: 1,
                                p: 1.5,
                            }}
                        >
                            <Typography
                                variant="caption"
                                sx={{
                                    color: isAssistant ? 'primary.main' : 'warning.main',
                                    fontWeight: 600,
                                    letterSpacing: 0.3,
                                    display: 'block',
                                    mb: 0.5,
                                }}
                            >
                                {isAssistant ? 'Assistant' : 'User'}
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.primary' }}>
                                {turn.text}
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex', alignItems: 'center', gap: 1,
                            mt: 0.5,
                            flexDirection: isAssistant ? 'row' : 'row-reverse',
                        }}>
                            <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 11 }}>
                                {turn.time_of_day} {turn.offset_display ? `(${turn.offset_display})` : ''}
                            </Typography>
                            {isAssistant && (
                                <Tooltip title="Mark unhelpful (coming soon)">
                                    <IconButton size="small" sx={{ p: 0.25, color: 'text.disabled' }}>
                                        <ThumbDownIcon fontSize="inherit" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
};

export default TranscriptsTab;
